import { Component, Input, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
    selector: 'app-entity-summary',
    standalone : true,
    imports: [CommonModule, MatCheckboxModule],
    templateUrl: './entity-summary.component.html',
    styleUrls: ['./entity-summary.component.scss']
})
export class EntitySummaryComponent implements OnChanges {
  @Input() entityObject: string | undefined; //entity object JSON string
  @Input() entityDefinition: any;
  @Input() summaryTitle: string = '';
  @Input() summaryErrorText: string = '';
  @Input() displaySidenavSvg: boolean = true;
  @Input() displayWithRoundContainer: boolean = true;
  public summaryListItem: summaryItem[] = [];

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.entityObject != undefined) this.setItemSummary();
    else this.summaryListItem = [];
  }

  private setItemSummary() {
    this.summaryListItem = [];
    if (this.summaryErrorText == undefined && this.summaryErrorText != '') {
      let jsonSummary = undefined;
      if (this.entityObject && this.entityObject?.length > 0) jsonSummary = JSON.parse(this.entityObject);
      Object.keys(jsonSummary).forEach((key) => {
        if (this.entityDefinition[key] != undefined) {
          this.summaryListItem.push({
            name: this.entityDefinition[key].name,
            readOnly: true,
            type: this.entityDefinition[key].type,
            value: jsonSummary[key]?.value,
            visibility: jsonSummary[key]?.visibility,
            style: jsonSummary[key]?.style,
          });
        }
      });
    }
  }
}

export interface summaryItem {
  value: any;
  visibility: boolean;
  style: 'italic' | 'none';
  type: string;
  name: string;
  readOnly: boolean;
}
